import { render, staticRenderFns } from "./Zipcode.vue?vue&type=template&id=4c36037e&"
import script from "./Zipcode.vue?vue&type=script&lang=ts&"
export * from "./Zipcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports